import React, { useRef } from 'react'
import Header from '../../Components/Header/Header'
import CustomDropdown from '../../Components/DropDown/CustomDropdown'
import Icons from '../../Constants/Icons'
import { useState, useEffect } from 'react'
import CustomPagination from '../../Components/CustomPagination/CustomPagination'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import {
  onAPiCallGetWithOutCheckInEvent,
  apiCallGetEventStatus,
  onAPiCallSearchEvent,
  onAPiCallToggleEventFeatured,
  onApiCallSubmitEvent
} from '../../Core/Apicall'
import UpcomingEventsScreen from '../../Components/CustomDashboardScreen/UpcomingEventsScreen'
import { useLocation, useNavigate } from 'react-router-dom'
import EmptyData from '../../Components/EmptyData/EmptyData'
import UseDebounce from '../../Components/UseDebounce'

function WithOutCheckInEvent() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const statusDropdownItem = ['All', 'Activate', 'Deactivate']
  const [initialPage, setInitialPage] = useState(0)
  const [event, setEvent] = useState()
  const [searchValue, setSearchValue] = useState('')
  const [dropdownLabelSelect, setDropdownLabelSelect] = useState('All')
  const debouncedInput = UseDebounce(searchValue, 500)
  const location = useLocation();
  const page = Number(new URLSearchParams(location.search).get("page")) || 1;


  const PAGE_SIZE = 15

  const handleSelect = (status) => {
    setDropdownLabelSelect(status);
    if (searchValue == "") {
      onApiEventTypeList(0, status);
    } else {
      searchFilterFunction({
        text: searchValue,
        page: 0,
        status: status
      });
    }
  };

  const isInitialRender = useRef(true)

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    searchFilterFunction({text:searchValue, page:0, status:dropdownLabelSelect});
  }, [debouncedInput]);

  const handleInputChange = e => {
    const searchText = e.target.value
    setSearchValue(searchText)
  }
  const searchFilterFunction = async ({text, page = 0, status = dropdownLabelSelect}) => {
    dispatch(setLoadingTrue());
    const param = {
      searchQuery: text,
      offset: page + 1,
      limit: PAGE_SIZE,
      status: status,
    };
    console.log("param", param);


    try {
      const res = await onApiCallSubmitEvent(param);
      setEvent(res);
      setInitialPage(page);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  useEffect(() => {
    setInitialPage(page - 1);
    if (searchValue) {
      searchFilterFunction({ text: searchValue, page: page - 1, status: dropdownLabelSelect });
    } else {
      onApiEventTypeList(page - 1, dropdownLabelSelect);
    }
  }, [page]);

  const onApiEventTypeList = async (selectedPage, dropdownLabelSelect) => {
    dispatch(setLoadingTrue())
    const param = {
      status: dropdownLabelSelect,
      offset: selectedPage + 1,
      limit: PAGE_SIZE
    }
    try {
      const response = await onAPiCallGetWithOutCheckInEvent(param)
      setInitialPage(selectedPage ?? 0)
      setEvent(response)
      dispatch(setLoadingFalse())
    } catch (error) {
      console.error('Error fetching event types:', error)
      dispatch(setLoadingFalse())
    }
  }
  const handelEnabled = async (data) => {
    dispatch(setLoadingTrue())
    const param = {
      eventId: data.eventId,
      isEnabled: !data.isEnabled
    }
    try {
      const res = await apiCallGetEventStatus(param)

      setEvent(prevData => {
        const updatedData = prevData.data.map(item => {
          if (item.eventId === data.eventId) {
            return { ...item, isEnabled: !item.isEnabled }
          }
          return item
        })
        return { ...prevData, data: updatedData }
      })
      dispatch(setLoadingFalse())
    } catch (error) {
      dispatch(setLoadingFalse())
    }
  }

  const onClickFeaturedStatus = async (data) => {
    dispatch(setLoadingTrue());
    const param = {
      eventId: data.eventId,
      isFeatured: !data.isFeatured,
    };
    try {
      const res = await onAPiCallToggleEventFeatured(param);
      setEvent((prevData) => {
        const updatedData = prevData.data.map((item) => {
          if (item.eventId === data.eventId) {
            return { ...item, isFeatured: !item.isFeatured };
          }
          return item;
        });
        return { ...prevData, data: updatedData };
      });
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  const handleAddEvent = () => {
    navigate('/EventUpdate', { state: { AdminEvent: true } })
  }
  return (
    <div>
      <Header name={'Submited Events'} />
      <div className='astrologers-list-parent padding-top-bottom'>
        <div className='frame-parent2'>
          <div className='custom-box-user'>
            <div className='category_button'>
              <button onClick={handleAddEvent}>Create Event</button>
            </div>
            <div className='custom-container-dropdown-div'>
              <CustomDropdown
                dropDownLabel={dropdownLabelSelect}
                items={statusDropdownItem}
                color='blue'
                onSelect={handleSelect}
                customLabelStyle={{
                  fontWeight: '400',
                  color: 'white'
                }}
              />
            </div>

            <div className='custom-box-search-div'>
              <img className='custom-image' alt='' src={Icons.ic_search} />
              <input
                type='text'
                className='searchTextInput'
                placeholder='Search'
                value={searchValue}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='Event-custom-style'>
        <div className='lastWeekEndDiv Event-AlignSelf-stretch'>
          <div className='user_title event-flex-container'>
            Submited Events list
          </div>

          <div className='Achievements-class-name'>
            <div className='achievement-content'>
              <div className="achievement-content-header">
                <div className="lastWeekEndDivGreyColor w-8">image</div>
                <div className="lastWeekEndDivGreyColor w-10">Name</div>
                <div className="lastWeekEndDivGreyColor w-22">Events Name</div>

                <div className="lastWeekEndDivGreyColor w-30">Date & times</div>
                <div className="lastWeekEndDivGreyColor w-10">Actions</div>
                <div className="lastWeekEndDivGreyColor w-10">Status</div>
                <div className="lastWeekEndDivGreyColor w-10">Featured</div>
              </div>

              <div className='scrollable-container transform_data'>
                <UpcomingEventsScreen
                  adminEventEdit={true}
                  handelEnabled={handelEnabled}
                  data={event?.data}
                  onClickFeaturedStatus={onClickFeaturedStatus}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {event?.data.length == 0 && (
        <div className='empty-centered'>
          <EmptyData />
        </div>
      )}
      {event?.data.length != 0 && (
        <div className='Custom-Pagination'>
          <CustomPagination
            pageCount={Math.ceil((event?.totalCount || 0) / PAGE_SIZE)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              setInitialPage(selected);
              navigate(`/SubmitedEvent?page=${selected + 1}`);
              if (searchValue == "") {
                onApiEventTypeList(selected, dropdownLabelSelect);
              } else {
                searchFilterFunction({text:searchValue, page:selected, status:dropdownLabelSelect});

              }
            }}


          />
        </div>
      )}
    </div>
  )
}
export default WithOutCheckInEvent
